import { render, staticRenderFns } from "./detail-photo-list.vue?vue&type=template&id=4c365a8a&scoped=true&"
import script from "./detail-photo-list.vue?vue&type=script&lang=js&"
export * from "./detail-photo-list.vue?vue&type=script&lang=js&"
import style0 from "./detail-photo-list.vue?vue&type=style&index=0&id=4c365a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c365a8a",
  null
  
)

export default component.exports